import Joi from "joi-browser";
import useConfigureForm from "../useConfigureForm";
import { DelayMode } from "../../Models/Delay";

export default useDelayForm;

export const delayNodeConfigSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow(null, "").label("Description"),
  delayMode: Joi.string().required().label("Delay Mode"),
  delaySeconds: Joi
    .when("delayMode", {
      is: DelayMode.FIXED,
      then: Joi.number().min(0).required(),
      otherwise: Joi.number(),
    })
    .label("Delay Seconds"),
  delayExpression: Joi
    .when("delayMode", {
      is: DelayMode.FIXED,
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Delay Expression"),
    }),
  offsetSeconds: Joi.number().label("Offset Seconds"),
  minimumDelaySeconds: Joi.number().label("Minimum Delay Seconds"),
  skipIfPast: Joi.boolean().label("Skip If Past")
};

export function getDelayNodeConfigureData(delayNode) {
  return {
    name: delayNode.name,
    description: delayNode.description,
    delayMode: delayNode.delayMode,
    delaySeconds: delayNode.delaySeconds,
    delayExpression: delayNode.delayExpression,
    offsetSeconds: delayNode.offsetSeconds,
    minimumDelaySeconds: delayNode.minimumDelaySeconds,
    skipIfPast: delayNode.skipIfPast
  };
}

function useDelayForm(delayNodeConfig, validationErrors) {
  const { formState, validate, errors, updateFormState } = useConfigureForm(
    () => getDelayNodeConfigureData(delayNodeConfig),
    delayNodeConfigSchema,
    validationErrors,
  );

  return {
    formState,
    updateFormState,
    errors,
    validate,
  };
}
